import { translate, translateFormatter, type RichTextFormatter } from '@/domains/core/localization/translate';
export const {
  soldBy,
  otherOffers,
  offersViewed,
  offersFromOthers,
  offersViewMore,
  offerSelledBy
} = translate({
  "soldBy": "Sold by ",
  "otherOffers": "See other offers",
  "offersViewed": "Product being viewed",
  "offersFromOthers": "Offers from other sellers",
  "offersViewMore": "View More",
  "offerSelledBy": "Sold by"
});
export const availableBy = translateFormatter<{
  total: number;
}>("Product available from {total} other seller(s)", undefined, undefined, "en");
export const otherVendors = translateFormatter<{
  total: number;
  text: RichTextFormatter;
}>(" and <text>{total, plural, =1 {1 other seller} other {# other sellers}}</text>", undefined, undefined, "en");
export const discoverTheStore = translateFormatter<{
  brandName: string;
}>("Discover the {brandName} store", undefined, undefined, "en");